define('Designrequest.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function DesignrequestModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/Designrequest.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    DesignrequestModel.prototype = Object.create(SCModel.prototype);
    DesignrequestModel.prototype.constructor = DesignrequestModel;
 
    return DesignrequestModel
})
